import React, { useState } from 'react';
import { CaseEntry } from '../../graphql/graphql';
import CaseChatEntryFileToDocumentation from './CaseChatEntryFileToDocumentation';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { CASE_DETAIL_QUERY } from './Case.query';
import Loading from '../Loading';

interface Props {
	entry: CaseEntry;
	onSuccess?: () => void;
}

const CaseChatEntryFileToDocumentationWrapper: React.FC<Props> = props => {
	const [patientId, setPatientId] = useState();
	const [originalId, setOriginalId] = useState();
	const [isLoading, setIsLoading] = useState(false);

	useEffectAsync(async () => {
		setIsLoading(true);
		const result = await apiClient.graphql({
			query: CASE_DETAIL_QUERY,
			variables: { id: props.entry.caseId },
			fetchPolicy: 'network-only',
		});

		if (result?.data?.case?.patientId) {
			setPatientId(result?.data?.case?.patient?.id);
			setOriginalId(result?.data?.case?.childId || result?.data?.case?.patientId);
		}
		setIsLoading(false);
	}, []);

	if (!patientId || !originalId || isLoading) {
		return <Loading />;
	}

	return (
		<CaseChatEntryFileToDocumentation
			{...props}
			patientId={patientId}
			originalId={originalId}
		/>
	);
};

export default CaseChatEntryFileToDocumentationWrapper;
